import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { CompanyManifestResponseDto } from 'theSource/queries/useCompanyManifestQuery/types';
import {
  ErrorResponseDto,
  ResponseDto,
  SubscriberEditRequestDto,
} from 'theSource/types';
import {
  GET_COMPANY_MANIFEST_QUERY_KEY,
  GET_CONTENT_SETTINGS_QUERY_KEY,
  GET_SUBSCRIBER_QUERY_KEY,
  UPDATE_SUBSCRIBER_QUERY_KEY,
} from 'theSource/queries';
import {
  getLocalLanguage,
  ACCEPTED_VALUES,
} from 'theSource/features/Login/utils';
import { mapOptions, useApiMutation } from 'theSource/utils';
import { FormElement } from 'enrollment/components/Shared/FormElement';

export const Language = () => {
  const [prefLanguage, setprefLanguage] = useState(getLocalLanguage());
  const setLocalLanguage = (desiredLanguage: string) => {
    localStorage.setItem('preferred_language', desiredLanguage);
  };

  const { mutate: updateSubscriber } = useApiMutation<
    ResponseDto,
    ErrorResponseDto,
    SubscriberEditRequestDto
  >({
    queryKey: UPDATE_SUBSCRIBER_QUERY_KEY,
    queryKeysToInvalidate: GET_SUBSCRIBER_QUERY_KEY,
    method: 'put',
    endpoint: '/subscriber',
    getErrorMessage: (error) => error.response?.data?.details,
    onSuccess: () => {
      queryClient.invalidateQueries(GET_CONTENT_SETTINGS_QUERY_KEY);
    },
  });

  const queryClient = useQueryClient();
  const manifestData: CompanyManifestResponseDto = queryClient.getQueryData(
    GET_COMPANY_MANIFEST_QUERY_KEY
  )!;

  const { t, i18n } = useTranslation('pages.login');
  const languageOptions = mapOptions(manifestData?.enabled_languages || []);

  const handleLanguageChange = (event: any) => {
    const newLanguage = event.target.value;
    if (ACCEPTED_VALUES.includes(newLanguage) && newLanguage !== prefLanguage) {
      setprefLanguage(newLanguage);
      updateSubscriber({
        subscriber: { preferred_locale: newLanguage },
      });
      setLocalLanguage(newLanguage);
      i18n.changeLanguage(newLanguage);
    }
  };

  return (
    <FormElement
      data-testid="preferred-language"
      inputId="preferred-language"
      formField="select"
      label={t('language')}
      rootClass="d-block mt-n3"
      value={prefLanguage !== null ? prefLanguage : undefined}
      options={languageOptions}
      hideFirstOption={true}
      onChange={handleLanguageChange}
    />
  );
};
